import { gsap, Back, Power2, Linear, Elastic } from "gsap";
import { thumbUrl, momentUrl } from "../api";
import { Members } from "./Members";
import { Cache } from "./Cache";
import { VideoPlayer } from "./Gallery/VideoPlayer";
import heart from "../img/heart.svg";
import heartSelected from "../img/heart-selected.svg";
import controlIcons from "../img/video-icons.png";

export const Gallery = function (isActive, isVertical, isLeft) {
    this.isVertical = isVertical;
    this.isLeft = isLeft;
    this.isActive = isActive;
    this.canvas = null;
    this.ctx = null;
    this.timeline = null;
    this.currentMomentIsActive = false;
    this.activateCurrentTimer = null;
    this.momentTagsTimer = null;
    this.padding = 40;
    this.currentID = null;
    this.current = null;
    this.scrollTimer = null;
    this.scrollTween = null;
    this.mouseState = "";
    this.scrollOffset = { x: 0, y: 0 };
    this.dragOffset = { x: 0, y: 0 };
    this.throwVelocity = { x: 0, y: 0 };
    this.tags = [];
    this.moments = {};

    this.visibleMoments = [];
    this.imageBuffer = 8;
    this.data = [];
    this.likedMoments = [];
    this.loopInterval = null;
    this.Members = new Members(isVertical, isLeft);
    this.hit = { x: 0, y: 0, width: 20, height: 20, opacity: 0 };
    this.isFirstLoad = isVertical ? false : true;

    this.filteredYears = [];
    this.isMonthView = true;
    this.years = {};
    this.allYears = [];
    this.currentYear = null;
    this.onSelectYear = null;

    this.animationTimer = 0;
    this.isAnimating = false;

    this.caption = {
        text: "",
        y: 0,
        opacity: 0,
        date: {
            y: 0,
            opacity: 0,
            text: "",
        },
    };
    this.captionTL = null;

    this.config = {
        selectOffsetX: 360,
        selectOffsetY: 300,
        horz: {
            selectScale: 1.4,
        },
        vert: {
            selectScale: 1.3,
        },
        like: {
            size: 30,
            radius: 32,
            padding: 15,
        },
        video: {
            font: "normal 500 28px Avenir",
            colour: "#ffffff",
            padding: 25,
        },
        bigYearText: {
            font: "normal 800 400px Avenir",
            colour: "#E1EAF9",
        },
        timeline: {
            width: 40,
            height: isVertical ? 120 : 160,
        },
        years: {
            spacing: 1400,
            peek: 200,
            primary: {
                scale: 0.9,
                rotation: 0,
                shadow: 20,
            },
            secondary: {
                scale: 0.6,
                rotation: -15,
                shadow: 0,
            },
            tertiary: {
                scale: 0.6,
                rotation: 15,
                shadow: 0,
            },
        },
        yearLineColour: "rgba(68, 112, 182, 0.25)",
        monthLineColour: "#333E48",
        yearLabel: {
            font: "normal 800 40px Avenir",
            colour: "#000000",
        },
        monthLabel: {
            font: "normal 400 24px Avenir",
            colour: "#605FB2",
        },
        centerLabel: {
            font: "normal 800 24px Avenir",
            fontSmall: "normal 800 20px Avenir",
            colour: "#605FB2",
        },
        centerLabelYear: {
            font: "normal 800 40px Avenir",
            colour: "#000000",
        },
        caption: {
            font: "normal 800 48px Avenir",
            colour: "#000000",
        },
        captionDate: {
            font: "normal 400 20px Avenir",
            colour: "#000000",
        },
    };

    this.init = (_filteredMomentsArray, _currentMomentID, _Timeline, _allMoments, _onLikeFunction, _filter, _setFilter, _filteredYears, _setCurrentMomentID, _isLikeView) => {
        this.canvas.width = this.canvas.offsetWidth * 2;
        this.canvas.height = this.canvas.offsetHeight * 2;
        this.ctx = this.canvas.getContext("2d");
        this.timeline = _Timeline;
        this.moments = {};
        this.visibleMoments = [];
        // if (!this.isVertical && _isLikeView) {
        //     this.data = _filteredMomentsArray.filter((m) => m.isLike);
        //     this.currentID = this.data[this.data.length - 1].id;
        //     this.current = this.getMomentById(this.currentID);
        // } else {
        this.data = [..._filteredMomentsArray];
        this.currentID = _currentMomentID;
        this.current = this.getMomentById(this.currentID);
        // }
        this.setCurrentMomentID = _setCurrentMomentID;
        this.allMoments = _allMoments;
        this.onLike = _onLikeFunction;
        this.isLikeView = _isLikeView;
        this.caption = {
            y: 20,
            opacity: 0,
            date: {
                y: 20,
                opacity: 0,
            },
        };

        if (_filteredYears) {
            this.allYears = this.getAllYears(_filteredYears);
        }

        clearTimeout(this.activateCurrentTimer);
        this.currentMomentIsActive = false;
        this.setVisibleMoments();

        this.Members.init(this, this.moments[this.current.id], _filter, _setFilter);

        this.scrollOffset.x = -this.moments[this.current.id].x;
        this.scrollOffset.y = -this.moments[this.current.id].y;
        this.introAnimation();

        for (const key in Cache.videos) {
            Cache.videos[key].pause();
            Cache.videos[key].muted = true;
        }
        Cache.add(heart);
        Cache.add(heartSelected);
        Cache.add(controlIcons);

        if (this.isActive) {
            this.updateCanvas();
        }
    };

    this.getCurrentYear = (_currentMomentID) => {
        const current = this.data.find((moment) => moment.id === _currentMomentID);
        return new Date(current.date).getFullYear();
    };

    this.getAllYears = (_filteredYears) => {
        const __allyears = _filteredYears
            .filter((year) => year.moments.length > 0)
            .map((_year, i) => {
                const __year = {
                    x: i * this.config.years.spacing,
                    y: 0,
                    index: i,
                    year: _year.year,
                    months: _year.months,
                    momentsTotal: _year.moments.length,
                    targetMoment: _year.moments[0],
                    moments: _year.moments.slice().slice(0, 3),
                    hover: false,
                    centerLine: {
                        x: 0,
                        top: 250,
                        height: this.canvas.height * 0.25,
                        offset: {
                            x: 0,
                            y: 0,
                            opacity: 1,
                            textY: 0,
                        },
                        momentsInMonth: 0,
                    },
                    bigYear: {
                        y: 0,
                        opacity: 0,
                    },
                };

                if (_year.year === this.currentYear) {
                    this.scrollOffset.x = -i * this.config.years.spacing;
                    if (__year.moments.find((id) => id === this.currentID)) {
                        console.log("already has currernt moment");
                        __year.moments = __year.moments.filter((id) => id !== this.currentID);
                        __year.moments.unshift(this.currentID);
                    } else {
                        __year.moments[0] = this.currentID;
                    }
                }

                this.years[_year.year] = __year;
                return __year;
            });
        return __allyears;
    };

    this.initYearView = (_filteredMomentsArray, _currentMomentID, _Timeline, _filter, _setFilter, _filteredYears, _selectYearView, onFilterChange) => {
        console.log(">>>> initYearView");
        this.moments = {};
        this.visibleMoments = [];
        this.data = [..._filteredMomentsArray];
        if (onFilterChange) {
            this.currentID = _currentMomentID;
            this.current = this.getMomentById(this.currentID);
        }

        console.log("this.currentID", this.currentID);
        this.current = this.getMomentById(this.currentID);
        this.currentYear = this.getCurrentYear(this.currentID);
        this.onSelectYear = _selectYearView;

        if (_filteredYears) {
            this.filteredYears = _filteredYears;

            this.allYears = this.getAllYears(_filteredYears);

            this.setVisibleYears();
        }

        // show years.
        this.visibleYears.map((yearNum) => {
            const year = this.years[yearNum];
            const tl = new gsap.timeline();
            year.moments.map((id, i) => {
                const moment = this.moments[id];
                tl.from(moment, { duration: 0.1, scale: moment.scale * 2, opacity: 0, ease: Linear.easeNone }, 0.2 - i * 0.05);
                tl.from(moment, { duration: 0.25, x: year.x, ease: Power2.easeInOut }, 0.3);
                return null;
            });
            return null;
        });
    };

    this.initYearMoments = (_yearNum) => {
        let centerWidth = 0;
        this.years[_yearNum].moments.map((id, i) => {
            const yearX = this.years[_yearNum].x;
            const { years } = this.config;
            const _momentData = this.data.find((_moment) => _moment.id === id);

            const moment = this.initMoment(_momentData);

            if (i === 0) {
                moment.shadow = years.primary.shadow;
                moment.x = yearX;
                moment.scale = years.primary.scale;
                centerWidth = moment.width * moment.scale * 0.5;
            }
            if (i === 1) {
                moment.scale = years.secondary.scale;
                moment.rotation = years.secondary.rotation;
                moment.crop = true;
                moment.y = 40;
                moment.x = yearX - centerWidth;
            }
            if (i === 2) {
                moment.scale = years.tertiary.scale;
                moment.rotation = years.tertiary.rotation;
                moment.crop = true;
                moment.y = 40;
                moment.x = yearX + centerWidth;
            }
            this.visibleMoments.push(moment);

            return null;
        });
    };

    this.setVisibleYears = () => {
        const index = this.years[this.currentYear].index;
        this.visibleYears = [];
        this.visibleMoments = [];
        let buffer = 0;
        while (buffer < 3) {
            if (buffer === 0) {
                this.visibleYears.push(this.currentYear);
                this.initYearMoments(this.currentYear);
            } else {
                if (this.allYears[index + buffer]) {
                    const __year = this.allYears[index + buffer];
                    this.visibleYears.push(__year.year);
                    this.initYearMoments(__year.year);
                }
                if (this.allYears[index - buffer]) {
                    const __year = this.allYears[index - buffer];
                    this.visibleYears.push(__year.year);
                    this.initYearMoments(__year.year);
                }
            }
            buffer++;
        }
    };

    this.setAnimationTimer = (seconds) => {
        this.isAnimating = true;
        window.requestAnimationFrame(this.update);
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(() => {
            this.isAnimating = false;
        }, seconds * 1000);
    };

    this.activateCurrent = () => {
        clearTimeout(this.activateCurrentTimer);

        if (!this.currentMomentIsActive) {
            if (this.captionTL) {
                this.captionTL.kill();
            }
            this.captionTL = new gsap.timeline({})
                .to(this.caption, { opacity: 0, y: 30, ease: Power2.easeOut, duration: 0.3 }, 0)
                .to(this.caption.date, { opacity: 0, y: 30, ease: Power2.easeOut, duration: 0.3 }, 0.1)
                .call(() => {
                    this.caption.text = this.current.caption;
                })
                .set(this.caption.date, { text: this.formatDate(this.current) })
                .to(this.caption.date, { opacity: 1, y: 0, ease: Power2.easeOut, duration: 0.35 }, 0.5)
                .to(this.caption, { opacity: 1, y: 0, ease: Power2.easeOut, duration: 0.35 }, 0.7);
        }
        this.currentMomentIsActive = true;
        clearTimeout(this.momentTagsTimer);

        // ----------------------------------------
        // Member tags / location tags / # tags
        // ----------------------------------------
        this.momentTagsTimer = setTimeout(() => {
            if (!this.Members.isActive) {
                this.Members.updateCurrent(this.moments[this.current.id]);
                this.tags = this.Members.show();
            }
        }, 750);

        const current = this.getMomentById(this.currentID);
        current.position = "current";
        current.isCurrent = true;
        if (current.media.mediaType === "image") {
            Cache.add(current.media.file);
        } else {
            Cache.addVideo(current.media.file);
            if (Cache.videos[current.media.file]) {
                Cache.videos[current.media.file].currentTime = 0;
                Cache.videos[current.media.file].play();
            }
        }

        for (let key in this.moments) {
            const moment = this.moments[key];
            if (this.isVertical) {
                const offsetY = current.height * 0.5 * (this.config.vert.selectScale - 1) + this.config.selectOffsetY - this.padding * 2;

                switch (this.moments[key].position) {
                    case "before":
                        gsap.to(moment, { scale: 1, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { y: offsetY, duration: 0.5, ease: Power2.easeInOut });
                        break;
                    case "after":
                        gsap.to(moment, { scale: 1, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { y: -offsetY, duration: 0.5, ease: Power2.easeInOut });
                        break;
                    default:
                        gsap.to(moment, { scale: this.config.vert.selectScale, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { y: 0, duration: 0.5, ease: Power2.easeInOut });
                        break;
                }
            } else {
                const offsetX = current.width * 0.5 * (this.config.horz.selectScale - 1) + this.config.selectOffsetX - this.padding * 2;

                switch (moment.position) {
                    case "before":
                        gsap.to(moment, { scale: 1, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { x: -offsetX, duration: 0.5, ease: Power2.easeInOut });
                        break;
                    case "after":
                        gsap.to(moment, { scale: 1, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { x: offsetX, duration: 0.5, ease: Power2.easeInOut });
                        break;
                    default:
                        gsap.to(moment, { scale: this.config.horz.selectScale, duration: 0.5, ease: Power2.easeInOut });
                        gsap.to(moment.offset, { x: 0, duration: 0.5, ease: Power2.easeInOut });
                        break;
                }
            }
        }
    };

    this.toggleMonthView = (isMonthView) => {
        this.isMonthView = isMonthView;

        gsap.killTweensOf(this.scrollOffset);
        clearTimeout(this.scrollTimer);
        clearTimeout(this.activateCurrentTimer);
        clearTimeout(this.momentTagsTimer);

        if (isMonthView) {
            //
        } else {
            this.Members.hide();
            this.timeline.hideTimeline();

            [...this.visibleMoments].map((moment, i) => {
                // console.log("intro", moment);
                const _moment = this.moments[moment.id];
                const _current = this.moments[this.current.id];
                gsap.to(_moment, { duration: 0.3, scale: 0.5, opacity: 0, x: _current.x, y: _current.y, ease: Power2.easeIn });
                return null;
            });
        }
    };

    this.deactivateCurrent = () => {
        if (this.Members.isActive) {
            this.Members.hide();
        }
        clearTimeout(this.momentTagsTimer);
        clearTimeout(this.activateCurrentTimer);
        this.moments[this.currentID].isCurrent = false;
        gsap.to(this.caption, { opacity: 0, y: 30, ease: Power2.easeOut, duration: 0.25, delay: 0.05 });
        gsap.to(this.caption.date, { opacity: 0, y: 30, ease: Power2.easeOut, duration: 0.25, delay: 0 });

        if (this.currentMomentIsActive) {
            this.currentMomentIsActive = false;
            for (let key in this.moments) {
                const moment = this.moments[key];
                if (moment.media.mediaType === "video") {
                    const video = Cache.videos[moment.media.file];
                    if (video) {
                        video.pause();
                        video.muted = true;
                    }
                }
                gsap.to(moment, { scale: 1, duration: 0.5, ease: Power2.easeOut });
                if (this.isVertical) {
                    gsap.to(moment.offset, { y: 0, duration: 0.5, ease: Power2.easeOut });
                } else {
                    gsap.to(moment.offset, { x: 0, duration: 0.5, ease: Power2.easeOut });
                }
            }
        }
    };

    // update moments data
    this.updateData = (_filteredMomentsArray) => {
        this.data = [..._filteredMomentsArray];
        // todo: UPDATE
        // console.log("todo: update canvas, based on new data from _f  ilteredMomentsArray");
    };

    this.introAnimation = () => {
        //

        [...this.visibleMoments].slice(0, 11).map((moment, i) => {
            // console.log("intro", moment);
            const tl = new gsap.timeline({ delay: this.isFirstLoad ? 0.5 : 0 });
            const _moment = this.moments[moment.id];
            if (i < 5) {
                tl.from(_moment, { duration: 0.25, scale: 1.5, ease: Power2.easeOut }, 0.4 - 0.1 * i);
                tl.from(_moment, { duration: 0.05, opacity: 0, ease: Power2.easeOut }, 0.4 - 0.1 * i);
                tl.from(_moment, { duration: 0.5, x: this.moments[this.current.id].x, y: this.moments[this.current.id].y, rotation: i === 0 ? 5 : Math.random() * 50 - 25, ease: Power2.easeInOut }, 0.8);
            } else {
                tl.from(_moment, { duration: 0.2, opacity: 0, ease: Power2.easeIn, delay: 0.7 });
            }
            return moment;
        });

        this.startActivateCurrentTimer(this.isFirstLoad ? 2500 : 1250);

        this.isFirstLoad = false;
    };

    this.compareModeTransition = () => {
        //
        clearTimeout(this.momentTagsTimer);
        clearTimeout(this.activateCurrentTimer);
        this.Members.hide();
        this.timeline.hideTimeline();

        [...this.visibleMoments].map((moment, i) => {
            // console.log("intro", moment);
            const _moment = this.moments[moment.id];
            const _current = this.moments[this.current.id];
            gsap.to(_moment, { duration: 0.3, scale: 0.5, opacity: 0, x: _current.x, y: _current.y, ease: Power2.easeIn });
            return null;
        });
    };

    this.yearModeTransition = () => {
        if (this.isMonthView) {
            clearTimeout(this.momentTagsTimer);
            clearTimeout(this.activateCurrentTimer);
            this.Members.hide();
            this.timeline.hideTimeline();
            [...this.visibleMoments].map((moment, i) => {
                // console.log("intro", moment);
                const _moment = this.moments[moment.id];
                const _current = this.moments[this.current.id];
                gsap.to(_moment, { duration: 0.3, scale: 0.5, opacity: 0, x: _current.x, y: _current.y, ease: Power2.easeIn });
                return null;
            });
        } else {
            console.log("> todo: year mode transition");
        }
    };

    this.getMomentIndex = (id) => {
        return this.data.find((_moment) => _moment.id === id).index;
    };

    this.getDistance = (x, y) => {
        return parseInt(Math.sqrt(x * x + y * y));
    };

    this.handleMouseMove = (e) => {
        // let _target = null;
        if (this.canvas && this.canvas.height) {
            let mouseY = e.clientY * 2 - this.canvas.height * 0.5;
            let mouseX = e.clientX * 2 - this.canvas.width * 0.5;

            if (this.isMonthView) {
                if (this.currentMomentIsActive && this.tags.length) {
                    if (isVertical && !isLeft) {
                        mouseX -= this.canvas.width;
                    }
                    // ---------------------------------------------
                    // IF MEMBER TAGS HOVER
                    // ---------------------------------------------
                    if (this.Members.isActive) {
                        const { range } = this.Members.config.hover;
                        const maxDistance = this.getDistance(range, range);
                        const { radius } = this.Members.config;

                        this.tags.map((tag) => {
                            const x = tag.x + tag.offset.x + tag.float.x - mouseX;
                            const y = tag.y + tag.offset.y + tag.float.y - mouseY;
                            if (x > -range && x < range && y > -range && y < range) {
                                // console.log("HOVER:", tag);
                                this.Members.onMagneticEnter(tag);
                                tag.distance = this.getDistance(x, y);
                                const amplitude = range * (1 - tag.distance / maxDistance);
                                const _x = (x * amplitude) / range;
                                const _y = (y * amplitude) / range;
                                gsap.killTweensOf(tag.offset);
                                gsap.to(tag.offset, { x: -_x, y: -_y, duration: 0.3, ease: Power2.easeOut });
                            } else {
                                this.Members.onMagneticLeave(tag);
                            }
                            return null;
                        });

                        this.tags = this.tags.sort((a, b) => b.distance - a.distance);
                        this.tags.map((tag, i) => {
                            if (i === this.tags.length - 1 && tag.distance < radius) {
                                this.Members.onHover(tag);
                            } else {
                                this.Members.onHoverEnd(tag);
                            }
                            return null;
                        });
                    }
                }
                // console.log("moved", mouseY, mouseX);
            } else {
                // YEAR VIEW CLICKS
                // const index = Math.round((-this.scrollOffset.x + clickX) / this.config.years.spacing);
                // this.updateCurrentYear(this.allYears[index].year);
                // this.onSelectYear();
            }
        }
    };

    this.handleClick = (e) => {
        let _target = null;
        let clickY = e.clientY * 2 - this.canvas.height * 0.5;
        let clickX = e.clientX * 2 - this.canvas.width * 0.5;

        if (this.isMonthView) {
            if (isVertical && !isLeft) {
                clickX -= this.canvas.width;
            }
            // ---------------------------------------------
            // IF MEMBER TAGS CLICK
            // ---------------------------------------------
            let clickedTag = null;
            if (this.Members.isActive) {
                const radius = this.Members.config.radius;
                this.tags.map((tag) => {
                    if (tag.distance < radius) {
                        clickedTag = tag;
                    }
                    return null;
                });
                if (clickedTag) {
                    this.Members.selectTag(clickedTag);
                    this.Members.onHoverEnd(clickedTag);
                }
            }
            // ---------------------------------------------
            // IF TIMELINE CLICK
            // ---------------------------------------------
            let clickedTimeline = null;
            if (!clickedTag) {
                const date = new Date(this.current.date);

                if (this.isVertical) {
                    if (this.isLeft) {
                        // vert left
                        if (clickX > this.canvas.width * 0.5 - this.config.timeline.height) {
                            clickedTimeline = true;
                        }
                    } else {
                        // vert right
                        if (clickX < this.canvas.width * -0.5 + this.config.timeline.height) {
                            clickedTimeline = true;
                        }
                    }
                    if (clickedTimeline) {
                        // set date offset for compare view:
                        const dateOffset = date.getMonth() - Math.round(clickY / 40);
                        date.setMonth(dateOffset);
                    }
                } else {
                    // default view
                    if (clickY > this.canvas.height * 0.5 - this.config.timeline.height) {
                        // offset of how many months away from current
                        const dateOffset = date.getMonth() + Math.round(clickX / 40);
                        date.setMonth(dateOffset);
                        clickedTimeline = true;
                    }
                }

                if (clickedTimeline) {
                    const __year = this.years[date.getFullYear()];
                    if (__year && __year.moments.length > 0) {
                        if (__year.months[date.getMonth()].moments.length) {
                            // if month line you click contains any moments:
                            const _momentID = __year.months[date.getMonth()].moments[0];
                            console.log("select first in month", _momentID);
                            this.updateCurrent(this.getMomentIndex(_momentID));
                            this.deactivateCurrent();
                            this.activateCurrent();
                            this.snapToCurrent();
                        } else {
                            // if month line you click DOES NOT contain any moments,
                            // select the first available moment in that YEAR.
                            // NOTE: There is no confition foran epmty year, yet.
                            console.log("select first in year", __year.moments[0]);
                            this.updateCurrent(this.getMomentIndex(__year.moments[0]));
                            this.deactivateCurrent();
                            this.activateCurrent();
                            this.snapToCurrent();
                        }
                    }
                }
            }

            // ---------------------------------------------
            // IF MOMENT / MOMENT UI CLICK
            // ---------------------------------------------
            if (!clickedTag && !clickedTimeline) {
                if (this.isVertical) {
                    _target = this.visibleMoments.find((_m) => {
                        return Math.abs(this.scrollOffset.y + _m.y + _m.offset.y - clickY) < _m.height * _m.scale * 0.5;
                    });
                } else {
                    _target = this.visibleMoments.find((_m) => {
                        return Math.abs(this.scrollOffset.x + _m.x + _m.offset.x - clickX) < _m.width * _m.scale * 0.5;
                    });
                }
                if (_target) {
                    //
                    // Check for UI clicks
                    // ----------------------------------
                    const click = {
                        x: this.isVertical ? clickX : clickX - (this.scrollOffset.x + _target.x + _target.offset.x),
                        y: this.isVertical ? clickY - (this.scrollOffset.y + _target.y + _target.offset.y) : clickY,
                        uiClick: false,
                    };

                    // check for like click --------------------------
                    if (click.x > _target.width * _target.scale * 0.5 - this.config.like.radius * 2 - this.config.like.padding) {
                        if (click.y < -_target.height * _target.scale * 0.5 + this.config.like.radius * 2 + this.config.like.padding) {
                            _target.isLike = !_target.isLike;
                            this.onLike(_target);

                            // TODO: set moment as liked.
                            _target.likeOffset = {
                                ..._target.likeOffset,
                                scale: 1,
                                opacity: 1,
                            };
                            gsap.to(_target.likeOffset, { scale: 2, opacity: 0, duration: 0.3, ease: Power2.easeOut });
                            click.uiClick = true;
                        }
                    }

                    if (_target.media.mediaType === "video" && Cache.videos[_target.media.file]) {
                        if (click.y > _target.height * _target.scale * 0.5 - 90) {
                            // check for "play" click --------------------------
                            if (click.x < -_target.width * _target.scale * 0.5 + 90) {
                                const video = Cache.videos[_target.media.file];
                                if (video.paused) {
                                    video.play();
                                } else {
                                    video.pause();
                                }
                                click.uiClick = true;
                            }
                            // check for "mute" click --------------------------
                            if (click.x > _target.width * _target.scale * 0.5 - 90) {
                                const video = Cache.videos[_target.media.file];
                                video.muted = !video.muted;
                                click.uiClick = true;
                            }
                        }
                    }

                    // this.hit.x = click.x + this.canvas.width * 0.5;
                    // this.hit.y = click.y + this.canvas.height * 0.5;
                    // this.hit.width = 20;
                    // this.hit.height = 20;
                    // this.hit.opacity = 1;
                    // this.hit.isCurrent = _target.isCurrent;
                    // gsap.to(this.hit, { duration: 0.5, opacity: 0 });

                    if (!click.uiClick) {
                        if (!_target.isCurrent) {
                            this.updateCurrent(_target.index);
                            this.deactivateCurrent();
                            this.activateCurrent();
                            this.snapToCurrent();
                        } else {
                            this.snapToCurrent(true);
                        }
                    }
                } else {
                    this.snapToCurrent();
                }
            }
        } else {
            // YEAR VIEW CLICKS
            const index = Math.round((-this.scrollOffset.x + clickX) / this.config.years.spacing);
            this.updateCurrentYear(this.allYears[index].year);
            this.onSelectYear();
        }
    };

    this.startDrag = (x, y) => {
        gsap.killTweensOf(this.scrollOffset);
        clearTimeout(this.scrollTimer);
        this.dragOffset.x = x;
        this.dragOffset.y = y;
    };
    this.onDrag = (x, y) => {
        this.mouseState = "dragging " + x + "," + y;
        this.updateScrollPosition(x, y);
    };
    this.onThrow = (x, y) => {
        this.mouseState = "throw";
        // calculate where throw will land
        // snap to nearest moment to throw target.
        const throwDistance = this.isVertical ? y * 40 : (y + x) * 40;
        const direction = -throwDistance / Math.abs(throwDistance);
        // console.log("THROW direction", direction, throwDistance);
        if (this.isMonthView) {
            let i = this.current.index;
            if (this.isVertical) {
                while (this.data[i - direction] && Math.abs(this.current.vertical.y - this.data[i].vertical.y) < Math.abs(throwDistance)) {
                    i -= direction;
                }
            } else {
                while (this.data[i + direction] && Math.abs(this.current.horizontal.x - this.data[i].horizontal.x) < Math.abs(throwDistance)) {
                    i += direction;
                }
            }
            if (i === this.current.index) {
                this.snapToCurrent();
                this.startActivateCurrentTimer(900);
            } else {
                if (this.isVertical) {
                    gsap.to(this.scrollOffset, { x: -this.data[i].vertical.x, y: -this.data[i].vertical.y, ease: Back.easeOut, duration: 0.6 });
                } else {
                    gsap.to(this.scrollOffset, { x: -this.data[i].horizontal.x, y: -this.data[i].horizontal.y, ease: Back.easeOut, duration: 0.6 });
                }
                this.updateCurrent(i);
                this.deactivateCurrent();
                this.startActivateCurrentTimer(900);
            }
        } else {
            let i = this.years[this.currentYear].index;
            let iCurrent = this.years[this.currentYear].index;
            while (this.allYears[i + direction] && Math.abs(i - iCurrent) < Math.abs(throwDistance / this.config.years.spacing)) {
                i += direction;
            }
            if (i === iCurrent) {
                this.snapToCurrentYear();
            } else {
                gsap.to(this.scrollOffset, { x: -this.allYears[i].x, y: 0, ease: Back.easeOut, duration: 0.6 });
                this.updateCurrentYear(this.allYears[i].year);
            }
        }
    };

    this.snapToCurrent = (isCurrent) => {
        this.mouseState = "snapping back";
        gsap.killTweensOf(this.scrollOffset);
        if (this.isVertical) {
            gsap.to(this.scrollOffset, { duration: 0.25, x: -this.current.x, y: -this.current.y, ease: Power2.easeInOut });
        } else {
            gsap.to(this.scrollOffset, { duration: 0.25, x: -this.current.x, y: -this.current.y, ease: Power2.easeInOut });
        }
        if (!isCurrent) {
            this.startActivateCurrentTimer();
        }
    };

    this.snapToCurrentYear = () => {
        this.mouseState = "snapping back";
        gsap.killTweensOf(this.scrollOffset);
        gsap.to(this.scrollOffset, { duration: 0.25, x: -this.years[this.currentYear].x, y: 0, ease: Power2.easeInOut });
    };

    this.startActivateCurrentTimer = (timeout) => {
        clearTimeout(this.activateCurrentTimer);
        this.activateCurrentTimer = setTimeout(
            () => {
                this.activateCurrent();
            },
            timeout ? timeout : 500
        );
    };

    this.scroll = (x, y) => {
        if (this.mouseState !== "scrolling" && Math.abs(x) + Math.abs(y) > 5) {
            this.mouseState = "scrolling";
            if (this.isMonthView) {
                this.deactivateCurrent();
            }
        }
        gsap.killTweensOf(this.scrollOffset);
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
            if (this.isMonthView) {
                this.snapToCurrent();
                this.startActivateCurrentTimer(500);
            } else {
                this.snapToCurrentYear();
            }
        }, 50);
        let _x = x;
        let _y = y;
        if (this.isVertical) {
            const galleryTop = this.scrollOffset.y + this.data[this.data.length - 1].top;
            const galleryBottom = this.scrollOffset.y + this.data[0].bottom;
            if (galleryTop > 0 || galleryBottom < 0) {
                _x = 0;
                _y = 0;
            }
        } else {
            if (this.isMonthView) {
                const galleryRight = this.scrollOffset.x + this.data[this.data.length - 1].right;
                const galleryLeft = this.scrollOffset.x + this.data[0].left;
                if (galleryRight < 0 || galleryLeft > 0) {
                    _x = 0;
                    _y = 0;
                }
            } else {
                const galleryRight = this.scrollOffset.x + this.allYears[this.allYears.length - 1].x;
                const galleryLeft = this.scrollOffset.x + this.allYears[0].x;
                if (galleryRight < 0 || galleryLeft > 0) {
                    _x = 0;
                    _y = 0;
                }
            }
        }
        this.updateScrollPosition(_x, _y);
    };

    this.updateScrollPosition = (x, y) => {
        if (this.isVertical) {
            // vertical
            this.scrollOffset.x = 0;
            this.scrollOffset.y += y + x * 2;

            if (this.moments[this.current.id].y + this.scrollOffset.y < -this.moments[this.current.id].height * 0.5) {
                // next moment left
                if (this.data[this.current.index - 1]) {
                    this.updateCurrent(this.current.index - 1);
                }
            }
            if (this.moments[this.current.id].y + this.scrollOffset.y > this.moments[this.current.id].height * 0.5) {
                // next moment right
                if (this.data[this.current.index + 1]) {
                    this.updateCurrent(this.current.index + 1);
                }
            }
        } else {
            if (this.isMonthView) {
                this.scrollOffset.x += y + x * 2;
                this.scrollOffset.y = 0;

                if (this.moments[this.current.id].x + this.scrollOffset.x > this.moments[this.current.id].width * 0.5) {
                    // next moment left
                    if (this.data[this.current.index - 1]) {
                        this.updateCurrent(this.current.index - 1);
                    }
                }
                if (this.moments[this.current.id].x + this.scrollOffset.x < -this.moments[this.current.id].width * 0.5) {
                    // next moment right
                    if (this.data[this.current.index + 1]) {
                        this.updateCurrent(this.current.index + 1);
                    }
                }
            } else {
                this.scrollOffset.x += y + x * 2;
                this.scrollOffset.y = 0;
                if (this.years[this.currentYear].x + this.scrollOffset.x > this.config.years.spacing * 0.5) {
                    // prev year
                    if (this.allYears[this.years[this.currentYear].index - 1]) {
                        this.updateCurrentYear(this.allYears[this.years[this.currentYear].index - 1].year);
                    }
                }
                if (this.years[this.currentYear].x + this.scrollOffset.x < -this.config.years.spacing * 0.5) {
                    // next year
                    if (this.allYears[this.years[this.currentYear].index + 1]) {
                        this.updateCurrentYear(this.allYears[this.years[this.currentYear].index + 1].year);
                    }
                }
            }
        }
        if (Math.abs(x) + Math.abs(y) > 2 && this.isMonthView) {
            // deselect currently active moment, only if movement is great enough.
            this.deactivateCurrent();
        }
    };

    this.updateCurrent = (index) => {
        this.currentID = this.data[index].id;
        this.setCurrentMomentID(this.currentID);
        this.current = this.moments[this.currentID] ? this.moments[this.currentID] : this.initMoment(this.data[index]);
        this.timeline.setDate(this.current.date);
        this.setVisibleMoments();
        this.current.position = "current";
        this.current.isCurrent = true;
    };

    this.updateCurrentYear = (_yearNum) => {
        this.currentYear = _yearNum;
        this.currentID = this.years[_yearNum].moments[0];
        this.current = this.moments[this.currentID] ? this.moments[this.currentID] : this.initMoment(this.data.find((_moment) => _moment.id === this.currentID));
        // this.timeline.setDate(this.current.date);
        this.setVisibleYears();
    };

    //
    // Create an array of momentIDs, to load into the image
    // cache. Number is determined by 'imageBuffer'.
    //
    this.setVisibleMoments = () => {
        //
        const currentMoment = this.getMomentById(this.currentID);
        const index = currentMoment.index;
        const visibleMoments = [currentMoment];
        currentMoment.position = "current";
        currentMoment.isCurrent = true;
        // populate visibleMomentsArray with moments
        // progressively getting fartheraway in the array.
        //     0
        //    / \
        //   1  2
        //  /    \
        // 3     4

        for (let i = 1; i < this.imageBuffer; ++i) {
            if (this.data[index - i]) {
                const _prev = this.data[index - i];
                const prev = this.moments[_prev.id] ? this.moments[_prev.id] : this.initMoment(_prev);
                visibleMoments.push(prev);
                prev.position = "before";
                prev.isCurrent = false;
            }
            if (this.data[index + i]) {
                const _next = this.data[index + i];
                const next = this.moments[_next.id] ? this.moments[_next.id] : this.initMoment(_next);
                visibleMoments.push(next);
                next.position = "after";
                next.isCurrent = false;
            }
        }
        visibleMoments.map((moment) => this.initMoment(moment));
        this.visibleMoments = visibleMoments;
        if (this.isMonthView) {
            this.updateCanvas();
        }
    };
    this.getMomentById = (_id) => {
        if (!this.moments[_id]) {
            this.initMoment(this.data.find((_moment) => _moment.id === _id));
        }
        return this.moments[_id];
    };

    this.initMoment = (_moment) => {
        if (!this.moments[_moment.id]) {
            this.moments[_moment.id] = {
                ..._moment,
                x: this.isVertical ? parseInt(_moment.vertical.x) : parseInt(_moment.horizontal.x),
                y: this.isVertical ? parseInt(_moment.vertical.y) : parseInt(_moment.horizontal.y),
                height: this.isVertical ? _moment.vertical.height : _moment.horizontal.height,
                width: this.isVertical ? _moment.vertical.width : _moment.horizontal.width,
                media: {
                    ..._moment.media,
                    thumb: thumbUrl(_moment.media.thumb),
                    file: momentUrl(_moment.media.file),
                },

                // canvas values
                isCurrent: this.currentID === _moment.id ? true : false,
                offset: { x: 0, y: 0, rotation: 0 },
                likeOffset: { x: 0, y: 0, scale: 0, opacity: 0 },
                opacity: 1,
                rotation: 0,
                scale: 1,
            };
            Cache.add(this.moments[_moment.id].media.thumb);
        }
        return this.moments[_moment.id];
    };
    this.drawYearLarge = () => {
        const text = new Date(this.moments[this.currentID].date).getFullYear();
        this.ctx.textAlign = "center";
        this.ctx.fillStyle = this.config.bigYearText.colour;
        this.ctx.font = this.config.bigYearText.font;
        this.ctx.fillText(text, this.canvas.width * 0.5, this.canvas.height, 1200);
    };
    this.syncLikes = (likedMoments) => {
        // in vertical mode, synchronise likes between both sides.
        for (const key in this.moments) {
            const isLiked = likedMoments.find((_id) => _id === key);
            if (isLiked) {
                this.moments[key].isLike = true;
            } else {
                this.moments[key].isLike = false;
            }
        }
    };

    // =============================
    // DRAW FUNCTIONS
    // ============================
    this.drawHeart = (_moment) => {
        const width = _moment.width * _moment.scale;
        const height = _moment.height * _moment.scale;
        const { radius, size, padding } = this.config.like;

        this.ctx.beginPath();
        this.ctx.globalAlpha = _moment.opacity * 0.25;
        this.ctx.ellipse(width * 0.5 - (padding + radius), height * -0.5 + (padding + radius), radius, radius, 0, 0, Math.PI * 2);
        this.ctx.closePath();
        this.ctx.fillStyle = "#000000";
        this.ctx.fill();
        this.ctx.globalAlpha = _moment.opacity;

        let _heart = _moment.isLike ? Cache.loaded[heartSelected] : Cache.loaded[heart];
        if (_heart) {
            this.ctx.drawImage(
                // Source image element
                _heart,
                0,
                0,
                _heart.width,
                _heart.height,
                width * 0.5 - (padding + radius + size * 0.5),
                height * -0.5 + (padding + radius + size * -0.5),
                size,
                size
            );

            if (_moment.likeOffset.opacity > 0) {
                this.ctx.globalAlpha = _moment.opacity * _moment.likeOffset.opacity;
                this.ctx.drawImage(
                    // Source image element
                    _heart,
                    0,
                    0,
                    _heart.width,
                    _heart.height,
                    width * 0.5 - (padding + radius + size * 0.5 * _moment.likeOffset.scale),
                    height * -0.5 + (padding + radius + size * -0.5 * _moment.likeOffset.scale),
                    size * _moment.likeOffset.scale,
                    size * _moment.likeOffset.scale
                );
            }
        }
    };
    this.roundedImage = (x, y, width, height, radius) => {
        this.ctx.beginPath();
        this.ctx.moveTo(x + radius, y);
        this.ctx.lineTo(x + width - radius, y);
        this.ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        this.ctx.lineTo(x + width, y + height - radius);
        this.ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        this.ctx.lineTo(x + radius, y + height);
        this.ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        this.ctx.lineTo(x, y + radius);
        this.ctx.quadraticCurveTo(x, y, x + radius, y);
        this.ctx.closePath();
        this.ctx.fillStyle = "#E1EAF9";
        this.ctx.fill();
    };
    this.drawMoment = (_m) => {
        const x = _m.x + _m.offset.x + this.scrollOffset.x + this.canvas.width * 0.5;
        const y = _m.y + _m.offset.y + this.scrollOffset.y + this.canvas.height * 0.5;
        const width = _m.width * _m.scale;
        const height = _m.height * _m.scale;
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.globalAlpha = _m.opacity;
        this.ctx.rotate(_m.rotation * (Math.PI / 180));

        if (_m.shadow) {
            this.ctx.shadowBlur = _m.shadow;
            this.ctx.shadowOffsetY = _m.shadow * 0.33;
        } else {
            this.ctx.shadowBlur = 0;
            this.ctx.shadowOffsetY = 0;
        }
        if (_m.crop) {
            // check if images to crop are wider than peek distance.
            const peekDist = this.config.years.peek * _m.scale;
            if (_m.width * 0.5 > peekDist) {
                this.roundedImage(-peekDist, height * -0.5, peekDist * 2, height, this.canvas.height * 0.02);
            } else {
                this.roundedImage(width * -0.5, height * -0.5, width, height, this.canvas.height * 0.02);
            }
        } else {
            this.roundedImage(width * -0.5, height * -0.5, width, height, this.canvas.height * 0.02);
        }
        this.ctx.clip();
        this.ctx.imageSmoothingEnabled = true;
        let _thumb = Cache.loaded[_m.media.thumb];
        let _photo = Cache.loaded[_m.media.file];
        let _video = Cache.videos[_m.media.file];

        // console.log(_thumb, _m);
        // if (_m.isCurrent) this.ctx.fillStyle = "#ff0000";
        // if (_photo && _m.isCurrent) this.ctx.fillStyle = "#0000ff";
        // if (!_m.isCurrent) this.ctx.fillStyle = "#00ff00";
        // if (!_m.isCurrent && _thumb) this.ctx.fillStyle = "#ffff00";
        // this.ctx.fillRect(width * -0.5, height * -0.5, width, height);

        if (_photo && _m.isCurrent && this.isMonthView) {
            // this.ctx.imageSmoothingEnabled = true;
            this.ctx.drawImage(
                // Source image element
                _photo,
                0,
                0,
                _photo.width,
                _photo.height,
                width * -0.5,
                height * -0.5,
                width,
                height
            );
            // this.ctx.imageSmoothingEnabled = false;
        } else if (_video && _m.isCurrent && this.isMonthView) {
            this.ctx.drawImage(
                // Source image element
                _video,
                0,
                0,
                _video.videoWidth,
                _video.videoHeight,
                width * -0.5,
                height * -0.5,
                width,
                height
            );
        } else if (_thumb) {
            this.ctx.drawImage(
                // Source image element
                _thumb,
                0,
                0,
                _thumb.width,
                _thumb.height,
                width * -0.5,
                height * -0.5,
                width,
                height
            );
        }

        if (_m.media.mediaType === "video" && this.isMonthView) {
            VideoPlayer(this.ctx, this.config, _m, _video, controlIcons);
        }

        // draw heart
        if (this.isMonthView) {
            this.drawHeart(_m);
        }

        this.ctx.restore();
        // }
    };

    this.drawYear = (yearNum) => {
        const year = this.years[yearNum];

        const cX = this.scrollOffset.x + year.x + this.canvas.width * 0.5;
        const cY = this.canvas.height;

        this.ctx.globalAlpha = 1;
        this.ctx.textAlign = "center";
        this.ctx.fillStyle = this.config.bigYearText.colour;
        this.ctx.font = this.config.bigYearText.font;
        this.ctx.fillText(yearNum, cX, cY, 1200);

        // draw centerline for year
        this.ctx.beginPath();

        this.ctx.moveTo(cX, cY);
        this.ctx.lineTo(cX, cY - year.centerLine.height + year.centerLine.offset.y);

        this.ctx.lineCap = "round";
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = "#C3D2E8";
        this.ctx.stroke();
        this.ctx.closePath();

        if (year.centerLine.height > 20) {
            this.ctx.ellipse(cX, cY - year.centerLine.height + year.centerLine.offset.y, 5, 5, 0, 0, Math.PI * 2);
        }
        this.ctx.fillStyle = "#C3D2E8";
        this.ctx.fill();

        // label
        this.ctx.globalAlpha = year.centerLine.offset.opacity;
        this.ctx.textAlign = "center";
        // draw moments in year
        this.ctx.font = this.config.centerLabel.font;
        this.ctx.fillStyle = this.config.centerLabel.colour;
        const yearLabel = `${year.momentsTotal} moments`;
        this.ctx.fillText(yearLabel, cX, cY - year.centerLine.height - 20, 400);
        // draw year label (small)
        this.ctx.font = this.config.centerLabelYear.font;
        this.ctx.fillStyle = this.config.centerLabelYear.colour;
        this.ctx.fillText(yearNum, cX, cY - year.centerLine.height - 60, 400);

        this.ctx.globalAlpha = 1;
    };

    this.formatDate = (moment) => {
        const _date = new Date(moment.date);
        const day = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][_date.getDay() - 1];
        const date = _date.getDate();
        const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][_date.getMonth()];
        const year = _date.getFullYear();
        return `${day ? day + " " : ""}${date} ${month} ${year}`;
    };

    this.drawCaption = () => {
        const current = this.moments[this.currentID];
        const cX = this.canvas.width * 0.5;
        const cY = this.canvas.height * 0.5 + current.height * 0.5 * (this.isVertical ? this.config.vert.selectScale : this.config.horz.selectScale) + this.padding;

        this.ctx.textAlign = "center";
        // draw moments date
        this.ctx.globalAlpha = this.caption.date.opacity;
        this.ctx.font = this.config.captionDate.font;
        this.ctx.fillStyle = this.config.captionDate.colour;
        this.ctx.fillText(this.caption.date.text, cX, cY + this.caption.date.y, 1000);
        // draw moment caption
        this.ctx.globalAlpha = this.caption.opacity;
        this.ctx.font = this.config.caption.font;
        this.ctx.fillStyle = this.config.caption.colour;
        this.ctx.fillText(this.caption.text, cX, cY + 50 + this.caption.y, 1000);
    };

    this.updateCanvas = () => {
        if (this.isActive) {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.ctx.imageSmoothingEnabled = false;

            if (!this.isVertical) {
                if (this.isMonthView) {
                    this.drawYearLarge();
                } else {
                    this.visibleYears.map((yearNum) => this.drawYear(yearNum));
                }
            }

            if (this.isMonthView) {
                this.drawCaption();
            }

            this.ctx.shadowColor = "rgba(0,0,0,0.15)";

            [...this.visibleMoments]
                .slice()
                .reverse()
                .map((moment) => {
                    return this.drawMoment(this.moments[moment.id]);
                });

            // this.ctx.restore();
            this.ctx.save();
            if (this.hit.isCurrent) {
                this.ctx.fillStyle = "#ff3333";
            } else {
                this.ctx.fillStyle = "#00FF66";
            }

            this.Members.update(this.ctx);

            this.ctx.globalAlpha = this.hit.opacity;
            this.ctx.fillRect(this.hit.x - this.hit.width * 0.5, this.hit.y - this.hit.height * 0.5, this.hit.width, this.hit.height);
            this.ctx.restore();

            window.requestAnimationFrame(this.updateCanvas);
        } else {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };

    return this;
};
